<template>
  <Modal :show='show' @close='$emit("cancel")'>
    <header>
      <h3>{{ title }}</h3>
    </header>
    <div class='modal-body'>
      <slot/>
    </div>
    <footer>
      <button v-if="cancelText !== false" @click='$emit("cancel")'>
        {{ cancelText }}
      </button>
      <button :class="{alerte : alerte}" @click='$emit("validate")' :disabled="disabled">
        {{ okText }}
      </button>
    </footer>
  </Modal>
</template>

<script>
import Modal from '@/components/Modal'
export default {

  name: 'Dialog',

  components: {
    Modal
  },

  props: {
    okText: String,
    cancelText: {
      type: [String, Boolean],
      default: 'Annuler'
    },
    title: String,
    show: Boolean,
    alerte: {
      type: Boolean,
      default: false
    },
    disabled: false
  }
}
</script>
